document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.testimonials').forEach(el => {

    const container = el.querySelector('.testimonials__main');
    if (! container) return;

    const items = Array.from(container.querySelectorAll('.testimonial'));
    const navNext = el.querySelector('.testimonials__nav-btn--right');
    const navPrev = el.querySelector('.testimonials__nav-btn--left');
    var currentItem = 0;

    function setHeight() {
      containerHeight = 0;
      for (let i = 0; i < items.length; i++) {
        containerHeight = (items[i].offsetHeight > containerHeight) ? items[i].offsetHeight : containerHeight;
      }
      container.style.height = containerHeight + 'px';
    }

    function go() {
      let itemHeight = 0;
      for (let i = 0; i < items.length; i++) {
        items[i].hidden = currentItem !== i;
        if (currentItem == i) {
          // console.log(items[i].offsetHeight);
          // container.style.height = items[i].offsetHeight + 'px';
        }
      }
    }

    function next() {
      currentItem = (currentItem == items.length - 1) ? 0 : currentItem + 1;
    }

    function prev() {
      currentItem = (currentItem == 0) ? items.length - 1 : currentItem - 1;
    }

    navNext.addEventListener('click', (e) => {
      next();
      go();
      e.preventDefault();
    });

    navPrev.addEventListener('click', (e) => {
      prev();
      go();
      e.preventDefault();
    });

    setHeight();

    window.addEventListener('resize', function(event) {
      setHeight();
    }, true);

  });

});
